import { gql } from 'graphql.macro';

export const GetDepotManager = gql`
query GetServiceCentreByPCID($pcid: Int!) {
		serviceCentreByPCID: serviceCentreByPCID(pcid: $pcid)
        {
            pCManager
        }
    }
`;